/* ============================================================================
   M4 — module-local override store (seed from mockup js/m4.js).
   In-memory and mutable for the session; not part of the shared dummyData.
   Zone Override is scoped to COURIER ACCOUNT CODES (not merchants/clients) —
   clientId holds the account code. Seeded with the Mumbai→Hyderabad example
   (M4.6) on the first visible account code so the demo shows on load.
   ========================================================================== */
export const OVERRIDES = [
  {
    id: 'ovr-acme-hyd',
    clientId: 'Amazon Transportation Services',
    field: 'destCity',
    value: 'Hyderabad',
    zone: 2,
    reason:
      'Acme negotiated FY27 commercials: Mumbai → Hyderabad billed as Zone 2 despite the metro upgrade.',
    from: '2026-04-01',
    to: null,
    agreement: 'a2',
    status: 'Active',
    by: 'ajeet.johri@prozo.com',
    at: '2026-03-30T11:20:00',
  },
]

let seq = 1
export const nextOverrideId = (clientId) => 'ovr-' + clientId + '-' + ++seq

export const activeOverrides = (clientId) =>
  OVERRIDES.filter((o) => o.clientId === clientId && o.status === 'Active')
